<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import BirthInsuranceData from '@/data/company-page-data/turk-nippon-sigorta/cross-pages/BirthInsurance'
export default {
  metaInfo: {
    title: 'Türk Nippon Sigorta Doğum Sigortası Fiyatları İçin Teklif Alın.',
    meta: [
      {
        name: 'description',
        content:
          'Türk Nippon Sigorta iki can hamilelik (doğum) sigortası teklifinizi online teklif aracından alabilir, doğum sigortası fiyatlarını karşılaştırabilirsiniz.'
      }
    ]
  },
  name: 'TurkNipponSigortaBirthInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: BirthInsuranceData.headerContent,
      crossPageContent: BirthInsuranceData.crossPageContent,
      faqTitle: BirthInsuranceData.faqTitle,
      faqTitleDesc: BirthInsuranceData.faqTitleDesc
    }
  }
}
</script>
